import React from "react";
import {
  Datagrid,
  List, NumberInput,
  SimpleShowLayout,
  TextField,
  TextInput, DateField,
} from "react-admin";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";

export const ProductCategoryList = (props) => (
  <List {...props} sort={{ field: 'updatedAt', order: 'DESC' }}>
    <Datagrid rowClick="show">
      <TextField source="title"/>
      {/* <TextField source="objectId"/> */}
      <DateField locales={"fa-IR"} source="createdAt"/>
      <DateField locales={"fa-IR"} source="updatedAt"/>
      <TextField source="order"/>
    </Datagrid>
  </List>
);

export const ProductCategoryEdit = (props) => (
  <EditView {...props}>
    <TextInput source="title"/>
    <NumberInput source="order"/>
  </EditView>
);

export const ProductCategoryShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title"/>
      <TextField source="objectId"/>
      <DateField locales={"fa-IR"} source="createdAt"/>
      <DateField locales={"fa-IR"} source="updatedAt"/>
      <TextField source="order"/>
    </SimpleShowLayout>
  </ShowView>
);

export const ProductCategoryCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title"/>
    <NumberInput source="order"/>
  </CreateView>
);
